<template>
  <scout-form
    label="最終学歴"
    has-child
  >
    <div class="boss-table-2-layout">
      <div
        :class="[{ 'is-modified': value }, 'boss-table-2-item', 'boss-table-2-item-body']"
        data-test="school-career-body"
      >
        <label
          v-for="(option ,i) in educationalBackgroundOptions"
          :key="i"
          class="pega-badge-radio pega-mr-5"
        >
          <input
            :checked="value === option.id"
            :value="option.id"
            :data-test="`education-${option.id}`"
            type="radio"
            @change="$emit('input', $event.target._value)"
          >
          <span
            :data-test="`education-name-${option.id}`"
            class="pega-badge-radio-text pega-badge-radio-check-mark"
          >{{ option.name }}</span>
        </label>
        <label class="display-inline vertical-alien-middle">以上</label>
      </div>
    </div>
    <div
      v-if="from !== undefined && to !== undefined"
      class="boss-table-2-layout"
      data-test="graduated"
    >
      <div class="boss-table-2-item boss-table-2-item-head">
        卒業年
      </div>
      <div
        :class="[{ 'is-modified': from || to }, 'boss-table-2-item', 'boss-table-2-item-body']"
        data-test="graduated-body"
      >
        <input
          v-model="internalFrom"
          :class="{ 'is-invalid-input': isInvalidGraduated }"
          class="boss-input"
          style="width: 6em;"
          type="number"
          max="9999"
          min="1"
          data-test="from"
          @keypress="onlyNumberInRange($event, 9999, 1)"
        >年
        〜
        <input
          v-model="internalTo"
          :class="{ 'is-invalid-input': isInvalidGraduated }"
          class="boss-input"
          style="width: 6em;"
          type="number"
          max="9999"
          min="1"
          data-test="to"
          @keypress="onlyNumberInRange($event, 9999, 1)"
        >年
        <validation-label
          v-if="isInvalidGraduated"
          label="正しい大小関係で範囲を入力してください。"
          data-test="graduated-validation"
        />
      </div>
    </div>
    <div
      v-if="deptCodes !== undefined"
      class="boss-table-2-layout"
      data-test="dept-codes"
    >
      <div class="boss-table-2-item boss-table-2-item-head">
        学部・学科コード
      </div>
      <div
        :class="[{ 'is-modified': deptCodes.length }, 'boss-table-2-item', 'boss-table-2-item-body']"
        data-test="dept-codes-body"
      >
        <div class="boss-layout-gap-large">
          <label
            v-for="educationalDepartment in educationalDepartments"
            :key="educationalDepartment.id"
            class="boss-checkbox"
            :data-test="`check-box-${educationalDepartment.id}`"
          >
            <input
              :checked="educationalDepartment.checked"
              class="boss-input-checkbox"
              type="checkbox"
              data-test="check-box"
              @change="update(educationalDepartment.id)"
            >{{ educationalDepartment.name }}
          </label>
        </div>
      </div>
    </div>
    <div
      v-if="freeWord !== undefined"
      class="boss-table-2-layout"
      data-test="graduated-school"
    >
      <div class="boss-table-2-item boss-table-2-item-head">
        学校名・学部名
      </div>
      <div
        :class="[{ 'is-modified': freeWord && operator }, 'boss-table-2-item', 'boss-table-2-item-body']"
        data-test="graduated-school-body"
      >
        <span class="pega-graduated-school-info">
          <span class="wrap-block">「学校名」「学部／学科名」からフリーワード検索を行います。</span><span class="wrap-block">（キーワード1語につき20文字以内）</span>
        </span>
        <br>
        <input
          :value="freeWord"
          class="boss-input boss-input-fill"
          :class="{ 'is-invalid-input': !!freeWordErrorMessage }"
          type="text"
          placeholder="複数入力時は半角・全角スペースで区切ってください"
          data-test="free-word"
          @change="$emit('update:freeWord', $event.target.value)"
        >
        <validation-label
          v-if="!!freeWordErrorMessage"
          :label="freeWordErrorMessage"
          data-test="free-word-validation"
        />
        <div class="boss-separated-small">
          <div class="boss-layout boss-layout-start boss-layout-gap-large">
            <label class="pega-input">
              <input
                :checked="operator === 'and'"
                name="school"
                class="boss-input-checkbox"
                type="radio"
                value="and"
                data-test="operator-and"
                @change="$emit('update:operator', $event.target.value)"
              >すべてのキーワードを含む
            </label>
            <label class="pega-input">
              <input
                :checked="operator === 'or'"
                name="school"
                class="boss-input-checkbox"
                type="radio"
                value="or"
                data-test="operator-or"
                @change="$emit('update:operator', $event.target.value)"
              >いずれかのキーワードを含む
            </label>
          </div>
        </div>
      </div>
    </div>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import { mapGetters } from 'vuex'
import eventValidations from '@/lib/eventValidations'
import ValidationLabel from '@/components/atoms/ValidationLabel'

export default {
  components: {
    ScoutForm,
    ValidationLabel
  },
  mixins: [eventValidations],
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    freeWord: {
      default: undefined,
      type: String
    },
    freeWordErrorMessage: {
      default: undefined,
      type: String
    },
    operator: {
      default: 'and',
      type: String,
      validator: v => v === 'and' || v === 'or'
    },
    from: {
      default: undefined,
      type: Number
    },
    to: {
      default: undefined,
      type: Number
    },
    deptCodes: {
      default: undefined,
      type: Array
    }
  },
  computed: {
    educationalBackgroundOptions () {
      return [{ id: null, name: '指定なし' }, ...this.educationalBackgroundMaster]
    },
    educationalDepartments () {
      return this.educationalDepartmentMaster.map((educationalDepartment) => {
        return {
          id: educationalDepartment.id,
          // 「その他」の場合のみ、名称の末尾に補足文をつける
          name: (educationalDepartment.id !== 3 /* その他 */)
            ? educationalDepartment.name
            : `${educationalDepartment.name}（芸術・スポーツなど）`,
          checked: this.internalDeptCodes.some(deptCode => deptCode === educationalDepartment.id)
        }
      })
    },
    isInvalidGraduated () {
      return !!this.from && !!this.to && this.from > this.to
    },
    internalDeptCodes: {
      get () {
        return this.deptCodes || []
      },
      set (value) {
        this.$emit('update:deptCodes', value)
      }
    },
    internalFrom: {
      get () {
        return this.from
      },
      set (value) {
        this.$emit('update:from', value ? Number(value) : null)
      }
    },
    internalTo: {
      get () {
        return this.to
      },
      set (value) {
        this.$emit('update:to', value ? Number(value) : null)
      }
    },
    ...mapGetters([
      'educationalBackgroundMaster',
      'educationalDepartmentMaster'
    ])
  },
  methods: {
    update (educationalDepartmentId) {
      // 指定されたidがinternalDeptCodes無いに存在するか否かで処理を分岐（削除 or 追加）
      if (this.internalDeptCodes.some(deptCodeId => deptCodeId === educationalDepartmentId)) {
        this.$set(this, 'internalDeptCodes', this.internalDeptCodes.filter(deptCodeId => deptCodeId !== educationalDepartmentId))
      } else {
        this.$set(this, 'internalDeptCodes', [...this.internalDeptCodes, educationalDepartmentId])
      }
    }
  }
}
</script>
